import { t } from "@/i18n-js/instance";
import { ConfirmationCardLayout } from "./ConfirmationCardLayout";

export interface InviteLinkConfirmationCardProps {
  members_joined_count?: number;
  name?: string;
  status?: string;
}

export const InviteLinkConfirmationCard = ({
  name,
  status,
  members_joined_count,
}: InviteLinkConfirmationCardProps) => {
  const membersJoinedText =
    members_joined_count != null
      ? t("help_widget.copilot.confirmation_card.members_count", {
          count: members_joined_count,
        })
      : undefined;

  return (
    <ConfirmationCardLayout
      title={t("help_widget.copilot.confirmation_card.invite_link_title")}
      attributes={[
        {
          label: t("help_widget.copilot.confirmation_card.name"),
          value: name,
        },
        {
          label: t("help_widget.copilot.confirmation_card.status"),
          value: status,
        },
        {
          label: t(
            "help_widget.copilot.confirmation_card.number_of_members_joined",
          ),
          value: membersJoinedText,
        },
      ]}
    />
  );
};
